import Svg, { Circle, Path, Rect } from "react-native-svg";

interface IconProps {
  size?: number;
  color?: string;
}

export function LinkedinIcon({ size = 16, color = "#0A66C2" }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <Path d="M6.53 8.42H2.94V20h3.59V8.42ZM4.74 2.67a2.08 2.08 0 1 0 0 4.16 2.08 2.08 0 0 0 0-4.16ZM20.94 13.36c0-3.49-1.86-5.11-4.34-5.11-2 0-2.9 1.1-3.4 1.87v-1.6H9.61V20h3.59v-5.73c0-1.51.29-2.98 2.17-2.98 1.86 0 1.88 1.74 1.88 3.08V20h3.59l.1-6.64Z" />
    </Svg>
  );
}

export function GithubIcon({ size = 16, color = "#000" }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill={color}>
      <Path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" />
    </Svg>
  );
}

export function DribbbleIcon({ size = 16, color = "#EA4C89" }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <Path d="M12 24C5.385 24 0 18.615 0 12S5.385 0 12 0s12 5.385 12 12-5.385 12-12 12zm10.12-10.358c-.35-.11-3.17-.953-6.384-.438 1.34 3.684 1.887 6.684 1.992 7.308a10.174 10.174 0 004.392-6.87zm-6.115 7.808c-.153-.9-.75-4.032-2.19-7.77l-.066.02c-5.79 2.015-7.86 6.025-8.04 6.4a10.143 10.143 0 006.29 2.166c1.42 0 2.77-.29 4.006-.816zM4.003 18.744c.23-.41 3.04-5.1 8.332-6.834.133-.043.266-.085.4-.12a44.414 44.414 0 00-.822-1.736c-5.09 1.527-10.03 1.462-10.478 1.454L1.432 12c0 2.6.974 4.98 2.57 6.744zM1.583 10.04c.457.008 4.67.036 9.476-1.266C9.082 5.39 6.83 2.71 6.514 2.314A10.2 10.2 0 001.583 10.04zM8.51 1.591c.328.41 2.61 3.085 4.568 6.53 4.353-1.632 6.2-4.106 6.396-4.39A10.14 10.14 0 0012 1.846c-1.21 0-2.39.212-3.49.745h0zm12.216 3.443c-.236.315-2.244 2.932-6.79 4.757.259.532.508 1.073.74 1.613.084.196.165.39.244.584 3.46-.434 6.9.263 7.24.338a10.075 10.075 0 00-1.434-7.292z" />
    </Svg>
  );
}

export function BehanceIcon({ size = 16, color = "#1769FF" }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill={color}>
      <Path d="M4.654 3c.461 0 .887.035 1.278.14.39.07.711.216.996.391s.497.426.641.747c.14.32.216.711.216 1.137 0 .496-.106.922-.356 1.242-.215.32-.566.606-.997.817.606.176 1.067.496 1.348.922s.461.957.461 1.563c0 .496-.105.922-.285 1.278a2.3 2.3 0 01-.782.887c-.32.215-.711.39-1.137.496a5.3 5.3 0 01-1.278.176L0 12.803V3zm-.285 3.978c.39 0 .71-.105.957-.285.246-.18.355-.497.355-.887 0-.216-.035-.426-.105-.567a1 1 0 00-.32-.355 1.8 1.8 0 00-.461-.176c-.176-.035-.356-.035-.567-.035H2.17v2.31c0-.005 2.2-.005 2.2-.005zm.105 4.193c.215 0 .426-.035.606-.07.176-.035.356-.106.496-.216s.25-.215.356-.39c.07-.176.14-.391.14-.641 0-.496-.14-.852-.426-1.102-.285-.215-.676-.32-1.137-.32H2.17v2.734h2.305zm6.858-.035q.428.427 1.278.426c.39 0 .746-.106 1.032-.286q.426-.32.53-.64h1.74c-.286.851-.712 1.457-1.278 1.848-.566.355-1.243.566-2.06.566a4.1 4.1 0 01-1.527-.285 2.8 2.8 0 01-1.137-.782 2.85 2.85 0 01-.712-1.172c-.175-.461-.25-.957-.25-1.528 0-.531.07-1.032.25-1.493.18-.46.426-.852.747-1.207.32-.32.711-.606 1.137-.782a4 4 0 011.493-.285c.606 0 1.137.105 1.598.355.46.25.817.532 1.102.958.285.39.496.851.641 1.348.07.496.105.996.07 1.563h-5.15c0 .58.21 1.11.496 1.396m2.24-3.732c-.25-.25-.642-.391-1.103-.391-.32 0-.566.07-.781.176s-.356.25-.496.39a.96.96 0 00-.25.497c-.036.175-.07.32-.07.46h3.196c-.07-.526-.25-.882-.497-1.132zm-3.127-3.728h3.978v.957h-3.978z" />
    </Svg>
  );
}

export function WebsiteIcon({ size = 16, color = "#666" }: IconProps) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" />
      <Path d="M2 12h20" />
      <Path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </Svg>
  );
}

/**
 * Neutral mark for jobs pulled straight from an employer's applicant tracking
 * system. Deliberately generic rather than a vendor logo: the meaningful brand
 * on those cards is the hiring company, not the ATS behind it.
 */
export function AtsBoardIcon({ size = 16, color = "#5e29ff" }: IconProps) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Rect x="2.5" y="7" width="19" height="13" rx="2.5" />
      <Path d="M8.5 7V5.5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2V7" />
      <Path d="M2.5 12.5h19" />
    </Svg>
  );
}

export function GoogleJobsIcon({ size = 16 }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Circle cx="12" cy="12" r="10" fill="#FFFFFF" />
      <Path
        d="M20.48 12.27c0-.68-.06-1.33-.18-1.95H12v3.69h4.75a4.07 4.07 0 0 1-1.76 2.67v2.21h2.85c1.66-1.53 2.64-3.79 2.64-6.62Z"
        fill="#4285F4"
      />
      <Path
        d="M12 20.9c2.38 0 4.37-.79 5.83-2.14l-2.85-2.21c-.79.53-1.8.84-2.98.84-2.29 0-4.24-1.55-4.93-3.62H4.12v2.29A8.8 8.8 0 0 0 12 20.9Z"
        fill="#34A853"
      />
      <Path
        d="M7.07 13.77A5.3 5.3 0 0 1 6.8 12c0-.61.1-1.2.27-1.77V7.94H4.12A8.8 8.8 0 0 0 3.1 12c0 1.42.34 2.76 1.02 4.06l2.95-2.29Z"
        fill="#FBBC05"
      />
      <Path
        d="M12 6.61c1.29 0 2.44.44 3.35 1.31l2.51-2.51C16.37 4.01 14.38 3.1 12 3.1a8.8 8.8 0 0 0-7.88 4.84l2.95 2.29c.69-2.07 2.64-3.62 4.93-3.62Z"
        fill="#EA4335"
      />
      <Rect
        x="1"
        y="1"
        width="22"
        height="22"
        rx="11"
        stroke="rgba(17,24,39,0.08)"
      />
    </Svg>
  );
}

export function BaytIcon({ size = 16 }: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Rect x="2" y="2" width="20" height="20" rx="6" fill="#0D6EFD" />
      <Path
        d="M8 7.5h4.15c2 0 3.35 1.05 3.35 2.76 0 1.02-.51 1.8-1.44 2.25 1.2.39 1.89 1.32 1.89 2.7 0 1.96-1.48 3.29-3.84 3.29H8V7.5Zm3.87 4.25c.84 0 1.34-.42 1.34-1.11 0-.69-.5-1.08-1.34-1.08h-1.5v2.19h1.5Zm.25 4.69c.99 0 1.57-.48 1.57-1.29 0-.81-.58-1.27-1.57-1.27h-1.75v2.56h1.75Z"
        fill="#FFFFFF"
      />
    </Svg>
  );
}
